import React, { useEffect, useState } from "react";
import { SyncOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { ACCOUNTURL } from "../../../components/pages/config/config";
import '../../../styles/Tsreject.css'

const Tsreject = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(false);
  const [error, setError] = useState(false);
  const [candidatename, setCandidatename] = useState('');
  const [weeks, setWeeks] = useState('');
  const [totalhours, setTotalhours] = useState('');
  const [invlist, setInvlist] = useState([]);
  const [comments, setComments] = useState('');
  const [label,setLabel] = useState('');

  useEffect(() => {
    const cantsdata = async () => {
      try {
        let datastring = { id: token };
        let api = `${ACCOUNTURL}tsgetrejectdetails`;
        let postData = {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(datastring),
        };

        let response = await fetch(api, postData);
        let res = await response.json();
        if (res.actionMsg === 1) {
          let data = res.datalist;
          setCandidatename(data.candidatename);
          setWeeks(data.weeks);
          setLabel(data.label);
          setTotalhours(data.thours);
          setInvlist(data.invlist);
          setForm(true);
        } else {
          setError(true);
        }
      } catch (err) {
        let errorMessage = err.message || 'Contact Admin';
        toast.error(errorMessage, { duration: 2000 });
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    const timeoutId = setTimeout(() => {
      cantsdata();
    }, 1000);
    return () => {
      setLoading(true);
      clearTimeout(timeoutId);
    };
  }, [token]);


  const handleSave = async() => {
    if(comments === null || comments === ''){
      alert('enter comments')
    }
    else{
      try{
        let datastring = {
          'id' : token,
          'comments' : comments
        }
        let api = `${ACCOUNTURL}tsrejected`
        let postData = {
          'method' : 'post',
          'headers' : {'content-type':'application/json'},
          'body':JSON.stringify(datastring)
        }
        let response = await fetch(api,postData)
        let res = await response.json()
        if(res.actionMsg === 1){
          alert(''+res.Message+'')
          toast.success(''+response.message+'',{duration:2000})
          window.close()
        }
        else{
          alert(''+res.Message+'')
          toast.success(''+response.message+'',{duration:2000})
        }
      }
      catch(error){
        toast.error(''+error.message+'',{duration:2000})
      }
    }
  }

  return (
    <div className="tsreject-container">
      <div className="app-logo">
      <img className="logo" src="https://www.ampstek.com/assets/img/logo6.png" alt="SRSINFOWAY Logo" />
      </div>
      <title>Timesheet Rejected</title>

      {loading && (
        <div className="status-card">
          <div className="status-icon">
            <SyncOutlined spin style={{ color: 'orange', fontSize: '48px' }} />
          </div>
          <div className="status-content">
            <h3 className="status-title">Please Wait</h3>
            <p className="status-message">
              Timesheet is being verified and creation of access...
            </p>
          </div>
        </div>
      )}

      {error && (
        <div className="status-card">
          <div className="status-icon">
            <CloseCircleOutlined style={{ color: '#f30', fontSize: '48px' }} />
          </div>
          <div className="status-content">
            <h3 className="status-title">Error!</h3>
            <p className="status-message">
              Please contact admin. Send the queries to email: info@srsinfoway.com
              <br />
              <Link to="/" className="home-link">Return to Home</Link>
            </p>
          </div>
        </div>
      )}

      {form && (
        <div className="reject-form-container">
          <h2 className="form-title">Rejected Timesheet Details</h2>
          
          <div className="timesheet-details">
            <table className="timesheet-table">
              <tbody>
                <tr>
                  <td colSpan={2}>Candidate Name</td>
                  <td colSpan={2}>{candidatename}</td>
                </tr>
                <tr>
                  <td colSpan={2}>Week</td>
                  <td colSpan={2}>{label}</td>
                </tr>
                <tr>
                  <td colSpan={2}>Total Hours</td>
                  <td colSpan={2}>{totalhours}</td>
                </tr>
                <tr className="table-header">
                  <td colSpan={4}>Week List</td>
                </tr>
                <tr className="table-subheader">
                  <th>Date</th>
                  <th>Day</th>
                  <th>Hours</th>
                  <th>Reason</th>
                </tr>
                {invlist.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date}</td>
                    <td>{item.day}</td>
                    <td>{item.hours}</td>
                    <td>{item.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="comments-section">
            <label className="comments-label">Comments *</label>
            <textarea 
              className="comments-textarea"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Enter your comments here..."
              required
            />
          </div>

          <button className="submit-button" onClick={handleSave}>
            Submit
          </button>
        </div>
      )}
    </div>
  );
};

export default Tsreject;